module.exports = __webpack_public_path__ + "img/Teenies.1da5d7a7.jpg";